import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, EventEmitter, Inject, inject, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverPositions } from '@vendasta/galaxy/popover';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { MenuItem } from './common/fec/fec-menu/menu-item';
import { getCallToActionUrl, popUpShouldRedirectToCTA } from './pop-up-cta-check';

enum NavLinkType {
  NAVLINK = 0,
  SUBNAV = 1,
  DISABLED = 2,
  LOCKED = 3,
  POPOUT = 4,
  BETA = 5,
  NEW = 6,
}

@Component({
  selector: 'app-nav-item',
  templateUrl: './app-nav-item.component.html',
  styleUrls: ['./app-nav-item.component.scss'],
})
export class AppNavItemComponent implements OnInit {
  @Input() activeMenuId: string;
  @Input() item: MenuItem;
  @Output() clicked: EventEmitter<Event> = new EventEmitter<Event>();

  private readonly router = inject(Router);
  private readonly configService = inject(AppConfigService);

  public shouldExpandMenu = false;
  hasDirectLink: boolean;
  linkIsHandledInComponent: boolean;
  clickWillRedirectToCTA = false;

  readonly navLinkTypes = NavLinkType;
  navType: NavLinkType = NavLinkType.NAVLINK;

  readonly positions: ConnectedPosition[] = [{ ...PopoverPositions.Right }, { ...PopoverPositions.Bottom }];
  tooltip = `NAV_ITEMS.DEFAULT_DISABLED_TOOLTIP`;

  constructor(@Inject('PARTNER_ID') readonly partnerId$: Observable<string>) {}

  ngOnInit(): void {
    if (this.item.nestedItems) {
      const activeItems = this.item.nestedItems.filter((item) => this.activeMenuId.startsWith(item.menuId));
      this.shouldExpandMenu = activeItems.length > 0;
    }
    this.clickWillRedirectToCTA = popUpShouldRedirectToCTA(this.item);
    this.hasDirectLink = this.item.url && !this.item.ngRoute && !this.clickWillRedirectToCTA;
    this.linkIsHandledInComponent = (this.item.url && this.item.ngRoute) || this.clickWillRedirectToCTA;
    this.navType = this.getNavType();
  }

  onClick($event: Event): void {
    if (this.navType === NavLinkType.DISABLED) {
      $event.preventDefault();
      return;
    }

    this.clicked.emit($event);
  }

  navTabClicked($event: Event, item: MenuItem): void {
    if (this.navType === NavLinkType.DISABLED) {
      $event.preventDefault();
      return;
    }

    if (!item.popOut) {
      this.router.navigate([item.url]);
    }

    if (this.clickWillRedirectToCTA) {
      if (this.navType === NavLinkType.LOCKED) {
        $event.preventDefault();
      }
      this.handleLockedPopUpClick(item);
    }
  }

  private handleLockedPopUpClick(item: MenuItem): void {
    const ctaUrl = getCallToActionUrl(item);
    this.router.navigate([ctaUrl], { queryParams: { page: item.menuId } });
  }

  private getNavType(): NavLinkType {
    if (this.item.menuId === 'open-ssc' || this.item.menuId === 'open-meetings') {
      if (this.configService.config.isSuperAdmin) {
        this.tooltip = `NAV_ITEMS.SALES.SALES_POPOUTS_DISABLED_TOOLTIP`;
        return NavLinkType.DISABLED;
      }
    }

    if (this.item.locked) {
      return NavLinkType.LOCKED;
    }

    if (this.item.popOut) {
      return NavLinkType.POPOUT;
    }

    if (this.item.rightIcon) {
      return NavLinkType.SUBNAV;
    }

    if (this.item.badge === 'NAVIGATION_ITEM_BADGE_NEW') {
      return NavLinkType.NEW;
    }

    if (this.item.badge === 'NAVIGATION_ITEM_BADGE_BETA') {
      return NavLinkType.BETA;
    }
  }
}
